/**
 * The one signal that a person's account was deleted: `delete_my_account`
 * (`account_deletion` migration) overwrites `full_name` with this exact
 * string. There is no boolean flag - the migration deliberately did not add
 * one, so this sentinel is the only thing either client can branch on.
 */
const DELETED_USER_NAME = "Deleted user";

export function isDeletedUser(fullName: string | null | undefined): boolean {
  return fullName === DELETED_USER_NAME;
}
